export default {
  es: {
    'Friends and Family': 'Familiares y Amigos',
    Supplier: 'Suplidor',
    Automobile: 'Automobile',
    Motorcicle: 'Motocicleta',
    Motorcycle: 'Motocicleta',
    Truck: 'Camion',
    Walking: 'Caminando',
    Taxi: 'Taxi',
    Blue: 'Azul',
    Red: 'Rojo',
    Orange: 'Naranja',
    Green: 'Verde',
    Black: 'Negro',
    White: 'Blanco',
    Grey: 'Gris',
    Gold: 'Dorado',
    Silver: 'Plateado',
    Yellow: 'Amarillo',
    other: 'Otro',
    Other: 'Otro',
    CEDULA: 'Cédula',
    PASSPORT: 'Pasaporte',
    All: 'Todos',
    'Within the time': 'Vigente',
    'Out of the time': 'Expirado',
    'Not judged': 'No evaluado',
    'Out of time restriction': 'Expirado',
    'Access restricted due to penalty ({hours} hours remaining)': 'Acceso restringido por penalización ({hours} horas restantes)',
    'Card verification': 'Verificación por tarjeta',
    'Face recognition': 'Reconocimiento facial',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages.js